<script setup>
/**
 * Useful to display an icon in a component.
 * Automatically detects the current locale and displays the icon in the correct language.
 * Also supports raw SVG icons and renders appropriately.
 */
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const props = defineProps({
    icon: {
        type: String,
        required: true,
    },
    iconNL: {
        type: String,
        required: false,
    },
});

const icon = computed(() => (props.iconDutch != null && usePage().props.locale == 'nl' ? props.iconDutch : props.icon));

const isRaw = computed(() => icon.value.includes('<svg'));
</script>
<template>
    <div>
        <span v-if="isRaw" v-html="icon"> </span>
        <img v-else :src="icon" />
    </div>
</template>
